import { Auth0Provider, type AppState } from "@auth0/auth0-react";
import { QueryClientProvider } from "@tanstack/react-query";

import { queryClient } from "utils/queryClient";

import Auth0LogoutInitializer from "components/AuthInitializer";
import { AuthTokenProvider } from "components/AuthProvider/AuthProvider";
import Toaster from "components/Toaster";

import Routes from "routes/Routes";

import { SubscriptionProvider } from "context/Subscription";
import { UserProvider } from "context/User";
import { WakeLockProvider } from "context/WakeLock/WakeLock";
import { WebSocketProvider } from "context/WebSocket";

const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN as string;
const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID as string;
const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE as string;

export default function App() {
  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin + "/callback",
        audience: AUTH0_AUDIENCE,
      }}
      cacheLocation="localstorage"
      onRedirectCallback={(appState?: AppState) => {
        window.location.href = window.location.origin + (appState?.returnTo || window.location.pathname);
      }}
    >
      <AuthTokenProvider>
        <Auth0LogoutInitializer />
        <QueryClientProvider client={queryClient}>
          <WebSocketProvider>
            <UserProvider>
              <SubscriptionProvider>
                <WakeLockProvider>
                  <Routes />
                  <Toaster />
                </WakeLockProvider>
              </SubscriptionProvider>
            </UserProvider>
          </WebSocketProvider>
        </QueryClientProvider>
      </AuthTokenProvider>
    </Auth0Provider>
  );
}
